import {Check} from '@sparkware/app-utils';
import {VendorFilter} from './filters/vendor.filter';
import {CustomFilter} from './filters/custom.filter';
import {GameGroupFilter} from './filters/game-group.filter';
import {FilterType} from './filters/game-filter.interface';
import {AllRouletteFilter} from "./filters/all-roulette.filter";
import {AllBlackjackFilter} from "./filters/all-blackjack.filter";
import {SubgroupNameFilter} from "./filters/subgroup-name.filter";
import {AllPokerFilter} from "./filters/all-poker.filter";
import {AllBaccaratFilter} from "./filters/all-baccarat.filter";

const FILTERS = {
  'one-to-twenty-five': new CustomFilter(FilterType.categoryFilter, (gameInfo) => Check.isNumber(gameInfo.numberOfLines) && gameInfo.numberOfLines >= 1 && gameInfo.numberOfLines <= 24),
  'twenty-five-plus': new CustomFilter(FilterType.categoryFilter, (gameInfo) => Check.isNumber(gameInfo.numberOfLines) && gameInfo.numberOfLines >= 25),
  'roulette': new GameGroupFilter('Roulette'),
  'blackjack':  new GameGroupFilter('Blackjack'),
  'baccarat':  new GameGroupFilter('Baccarat'),
  'videoPoker':  new GameGroupFilter('VideoPoker'),
  'keno':  new GameGroupFilter('Keno'),
  'craps':  new GameGroupFilter('Craps'),
  'slots':  new GameGroupFilter(['Slot','VideoSlot']),
  'poker':  new CustomFilter( FilterType.categoryFilter, (game) => game.gameGroup.toLowerCase().indexOf('poker') !== -1),
  'live-poker':  new SubgroupNameFilter('poker'),
  'live-blackjack': new SubgroupNameFilter('blackjack'),
  'live-roulette':   new SubgroupNameFilter('roulette'),
  'live-baccarat':   new SubgroupNameFilter('baccarat'),
  'live-game-shows':   new SubgroupNameFilter('shows'),
  'live-elite-lounge':  new CustomFilter( FilterType.categoryFilter, (game) => game.isEliteLounge),
  'live-elite-lounge-or-exclusive': new CustomFilter(FilterType.categoryFilter, (game) => game.isEliteLounge || game.isExclusiveGame),
  'all-roulette':  new AllRouletteFilter(),
  'all-blackjack':  new AllBlackjackFilter(),
  'all-baccarat':  new AllBaccaratFilter(),
  'all-poker':  new AllPokerFilter(),
  'scratchCards':  new GameGroupFilter('Scratch Card'),
  'jackpot': new CustomFilter( FilterType.featureFilter, (game) => game.hasJackpot),
  'new': new CustomFilter( FilterType.featureFilter, (game) => game.isNewGame),
  'lowStakes': new CustomFilter( FilterType.featureFilter, (game) => game.hasLowStakes),
  'classicSlots': new CustomFilter( FilterType.featureFilter, (game) => game.isClassicSlot),
  'bonus': new CustomFilter( FilterType.featureFilter, (game) => game.hasBonusGames),
  'freeSpins': new CustomFilter( FilterType.featureFilter, (game) => game.hasFreeSpins),
  'highVolatility': new CustomFilter( FilterType.featureFilter, (game) => game.hasHighVolatility),
  'lowVolatility': new CustomFilter( FilterType.featureFilter, (game) => game.hasLowVolatility),
  'vendor_888': new VendorFilter('888'),
  'vendor_netent': new VendorFilter('NetEnt'),
  'vendor_playngo': new VendorFilter('play n go'),
  'vendor_redtiger': new VendorFilter('Red Tiger'),
  'vendor_quickspin': new VendorFilter('Quickspin'),
  'vendor_yggdrasil': new VendorFilter('yggdrasil'),
  'vendor_merkur': new VendorFilter('merkur'),
  'vendor_gamomat': new VendorFilter('gamomat'),
  'vendor_EGT': new VendorFilter('EGT'),
  'vendor_playtech': new VendorFilter('PlayTech'),
  'vendor_pragmatic': new VendorFilter('Pragmatic'),
  'vendor_blueprint': new VendorFilter('Blueprint'),
};

export {FILTERS};
